export default "__VITE_ASSET__a5d17b35__"